import { get, put } from '../lib/apiClient';

/** GET /organizations/{orgId}/audience */
export const getAudienceConfig = (orgId) =>
  get(`/organizations/${encodeURIComponent(orgId)}/audience`);

/** PUT /organizations/{orgId}/audience */
export const putAudienceConfig = (orgId, config) =>
  put(`/organizations/${encodeURIComponent(orgId)}/audience`, config);
